<template>
  <div class="container">

    <HeadComponent/>

    <div class="d-flex flex-column align-items-center justify-content-center min-vh-50 py-5">
      <div class="rounded-circle bg-primary d-flex align-items-center justify-content-center mb-3"
           style="width: 96px; height: 96px;">
        <span class="text-white fs-1 fw-bold">{{ name }}</span>
      </div>
      <h2 class="fw-bold mb-1">{{ name }}</h2>
<!--      <p class="text-secondary mb-2">-->
<!--        <i class="bi bi-calendar-event"></i>-->
<!--        {{ formattedBDate }}-->
<!--      </p>-->
      <transition name="fade">
        <div v-if="b_date" class="alert py-2 mb-3 animate__animated animate__pulse"
             :class="isBirthday ? 'alert-success' : 'alert-info'">
          <i class="bi" :class="isBirthday ? 'bi-gift-fill' : 'bi-emoji-smile'"></i>
          <span v-if="isBirthday">¡Feliz cumpleaños, {{ name }}!</span>
          <span v-else>Happy unbirthday, {{ name }}!</span>
        </div>
      </transition>
      <div class="d-flex gap-3 mt-3">
        <router-link to="/links" class="btn btn-primary">
          <i class="bi bi-link-45deg"></i> Links
        </router-link>
        <router-link to="/profile" class="btn btn-outline-secondary">
          <i class="bi bi-person"></i> Perfil
        </router-link>
      </div>
    </div>

    <FooterComponent/>
  </div>
</template>

<script>
import HeadComponent from "@/components/views/head/HeadComponent.vue";
import FooterComponent from "@/components/views/footer/FooterComponent.vue";

export default {
  components: {
    HeadComponent,
    FooterComponent
  },
  data() {
    return {
      name: '',
      b_date: ''
    };
  },
  computed: {
    formattedBDate() {
      if (!this.b_date) return '';
      const d = new Date(this.b_date);
      return d.toLocaleDateString();
    },
    isBirthday() {
      if (!this.b_date) return false;
      const today = new Date();
      const birth = new Date(this.b_date);
      return today.getDate() === birth.getDate() && today.getMonth() === birth.getMonth();
    }
  },
  mounted() {
    this.name = sessionStorage.getItem('name') || '';
    this.b_date = sessionStorage.getItem('b_date') || '';
  },
  methods: {
    logout() {
      this.$emit('logout');
    }
  }
};
</script>

<style scoped>
@import "https://cdnjs.cloudflare.com/ajax/libs/animate.css/4.1.1/animate.min.css";

.bg-light {
  //background: linear-gradient(135deg, #e0eafc 0%, #cfdef3 100%);
}
</style>
